import * as z from "zod";

export const StorefrontFallbackUrlSchema = z
  .string()
  .trim()
  .max(512, "Fallback URL is max 512 chars long")
  .refine((value) => {
    try {
      const url = new URL(value);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch {
      return false;
    }
  }, "Fallback URL must be an absolute HTTP(S) URL");

export const StorefrontFallbackInputSchema = z.object({
  entryPath: z
    .string()
    .trim()
    .refine((value) => value.startsWith("/"), "Entry path must start with a leading slash"),
  fallbackUrl: StorefrontFallbackUrlSchema,
});

export const StorefrontFallbackSchema = z.object({
  id: z.number(),
  shopId: z.number(),
  entryPath: z.string(),
  fallbackUrl: StorefrontFallbackUrlSchema,
  createdAt: z.coerce.date().transform((value) => value.toISOString()),
  updatedAt: z.coerce.date().transform((value) => value.toISOString()),
});

export const StorefrontFallbackCdnConfigSchema = z.object({
  version: z.literal(1),
  entryPath: z.string().min(1),
  fallbackUrl: StorefrontFallbackUrlSchema,
  updatedAt: z.iso.datetime(),
});

export type StorefrontFallbackInput = z.infer<typeof StorefrontFallbackInputSchema>;
export type StorefrontFallback = z.infer<typeof StorefrontFallbackSchema>;
export type StorefrontFallbackCdnConfig = z.infer<typeof StorefrontFallbackCdnConfigSchema>;
